import { css } from 'aphrodite';
import { ReactNode } from 'react';
import { overviewHoverPanelStyles as s } from './overviewHoverPanelStyles';

/**
 * Body of an Account Overview field hover card — a titled stack of `OverviewHoverRow`s.
 * `title` is optional so a panel that is one block of prose (the trial copy) can share the layout.
 */
export const OverviewHoverPanel = ({ title, children }: { title?: string; children: ReactNode }) => (
	<div className={css(s.panel)}>
		{!!title && <div className={css(s.title)}>{title}</div>}
		{children}
	</div>
);

/** One label/value line inside an `OverviewHoverPanel`. */
export const OverviewHoverRow = ({ label, children }: { label: string; children: ReactNode }) => (
	<div className={css(s.row)}>
		<span className={css(s.rowLabel)}>{label}</span>
		<span className={css(s.rowValue)}>{children}</span>
	</div>
);
